const disableStickyFooter = (page) =>
  page && page.enable_sticky_footer === false;

export default disableStickyFooter;
